import React, { useState, useEffect } from "react";
import {
    Button,
    Card,
    CardBody,
    Col,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Alert,
} from "reactstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { verify2faOtp } from "../../api/Auth";

const Verify2FAOtp = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [email, setEmail] = useState(location.state?.email || "");
    const [otp, setOtp] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!email) {
            navigate("/auth/login");
        }
    }, [email, navigate]);

    const handleVerify = async () => {
        if (!otp) {
            setErrorMsg("Please enter the OTP code.");
            return;
        }
        setLoading(true);
        setErrorMsg("");
        try {
            await verify2faOtp(email, otp);

            // Fetch user profile and save role
            try {
                const { getAdminProfile } = require("../../api/ApiServices");
                const profileRes = await getAdminProfile();
                let fetchedRole = "admin";
                if (profileRes && profileRes.payload && profileRes.payload.role) {
                    fetchedRole = profileRes.payload.role.name || profileRes.payload.role;
                }
                localStorage.setItem("userRole", fetchedRole);
                window.dispatchEvent(new Event("userRoleUpdated"));

                if (fetchedRole?.toLowerCase() === "judges") {
                    navigate("/admin/judges-dashboard");
                    return;
                }
            } catch (err) {
                console.error("Failed to fetch profile during 2FA", err);
            }

            navigate("/admin/index");
        } catch (error) {
            console.error(error);
            setErrorMsg(error.response?.data?.message || "Invalid or expired OTP.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Col lg="5" md="7">
            <Card className="bg-secondary shadow border-0">
                <CardBody className="px-lg-5 py-lg-5">
                    <div className="text-center text-muted mb-4">
                        <small>Two-Factor Authentication</small>
                        <h2 className="mt-2">Verify Your Login</h2>
                        <p className="text-sm">
                            An OTP has been sent to <strong>{email}</strong>. Please enter it below to complete your login.
                        </p>
                    </div>
                    <Form role="form" onSubmit={(e) => e.preventDefault()}>
                        <FormGroup className="mb-3">
                            <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <i className="ni ni-lock-circle-open" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                    placeholder="6-digit OTP"
                                    type="text"
                                    maxLength="6"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                    style={{ letterSpacing: "5px", textAlign: "center", fontSize: "20px", fontWeight: "bold" }}
                                />
                            </InputGroup>
                        </FormGroup>

                        {errorMsg && (
                            <Alert color="danger" className="text-center py-2 text-sm">
                                {errorMsg}
                            </Alert>
                        )}

                        <div className="text-center">
                            <Button
                                className="my-4 w-100"
                                color="primary"
                                type="button"
                                onClick={handleVerify}
                                disabled={loading}
                            >
                                {loading ? "Verifying..." : "Confirm Login"}
                            </Button>
                        </div>

                        <div className="text-center">
                            <a
                                className="text-dark"
                                href="#pablo"
                                onClick={(e) => {
                                    e.preventDefault();
                                    navigate("/auth/login");
                                }}
                            >
                                <small>Back to Login</small>
                            </a>
                        </div>
                    </Form>
                </CardBody>
            </Card>
        </Col>
    );
};

export default Verify2FAOtp;
